(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["upload-images"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';

  const TAG = 'dr-customer-upload';
  if (customElements.get(TAG)) return;

  const TYPES = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    webp: 'image/webp',
    heic: 'image/heic',
    heif: 'image/heif',
    avif: 'image/avif',
    mp4: 'video/mp4',
    mov: 'video/quicktime',
    m4v: 'video/x-m4v',
    webm: 'video/webm',
    ogv: 'video/ogg',
    ogg: 'video/ogg',
    '3gp': 'video/3gpp',
    '3g2': 'video/3gpp2'
  };

  const REGIONS =
    'AL:Alabama|AK:Alaska|AZ:Arizona|AR:Arkansas|CA:California|CO:Colorado|CT:Connecticut|DE:Delaware|DC:District of Columbia|FL:Florida|GA:Georgia|HI:Hawaii|ID:Idaho|IL:Illinois|IN:Indiana|IA:Iowa|KS:Kansas|KY:Kentucky|LA:Louisiana|ME:Maine|MD:Maryland|MA:Massachusetts|MI:Michigan|MN:Minnesota|MS:Mississippi|MO:Missouri|MT:Montana|NE:Nebraska|NV:Nevada|NH:New Hampshire|NJ:New Jersey|NM:New Mexico|NY:New York|NC:North Carolina|ND:North Dakota|OH:Ohio|OK:Oklahoma|OR:Oregon|PA:Pennsylvania|RI:Rhode Island|SC:South Carolina|SD:South Dakota|TN:Tennessee|TX:Texas|UT:Utah|VT:Vermont|VA:Virginia|WA:Washington|WV:West Virginia|WI:Wisconsin|WY:Wyoming|AB:Alberta|BC:British Columbia|MB:Manitoba|NB:New Brunswick|NL:Newfoundland and Labrador|NS:Nova Scotia|NT:Northwest Territories|NU:Nunavut|ON:Ontario|PE:Prince Edward Island|QC:Quebec|SK:Saskatchewan|YT:Yukon';

  const isRecord = (value) =>
    value !== null && typeof value === 'object' && !Array.isArray(value);

  const own = (object, key) =>
    Object.prototype.hasOwnProperty.call(object, key);

  const alias = (key) =>
    key === 'imgDriverLicenseUrl' ? 'imgDriverLicense' : key;

  const numericFields = new Set([
    'carYear',
    'vehicleMileage',
    'numberOfDoors',
    'numberOfSeats'
  ]);

  const regionEntries = REGIONS.split('|').map((entry) => entry.split(':'));

  const regionLookup = new Map(
    regionEntries.flatMap(([code, name]) => [
      [code.toLowerCase(), code],
      [name.toLowerCase(), code]
    ])
  );

  const normalDigits = (value) =>
    String(value)
      .normalize('NFKC')
      .replace(/[\u0660-\u0669\u06f0-\u06f9]/g, (character) =>
        String(character.charCodeAt(0) % 16)
      );

  const scalar = (value) =>
    typeof value === 'string' ||
    (typeof value === 'number' && Number.isFinite(value));

  // Preserve meaningful zero values, such as a new vehicle's mileage.
  const firstValue = (...values) =>
    values.find((value) => scalar(value) && String(value).trim() !== '');

  const safeUrl = (value, base) => {
    if (typeof value !== 'string') return '';

    try {
      const url = new URL(value, base);
      return url.protocol === 'https:' && !url.username && !url.password
        ? url.href
        : '';
    } catch {
      return '';
    }
  };

  const errorMessage = (payload, fallback) => {
    const value =
      typeof payload?.error === 'string'
        ? payload.error
        : payload?.error?.message || payload?.message;

    return typeof value === 'string' && value.trim()
      ? value.trim().slice(0, 300)
      : fallback;
  };

  const abortError = () =>
    new DOMException('Request interrupted.', 'AbortError');

  const currentYear = () => new Date().getFullYear();

  const prettyField = (input) =>
    input.closest('label')?.querySelector('span')?.textContent.trim() ||
    'This field';

  /*
   * One parser is used for typing, paste, loaded data, OCR, and saving.
   * No digit-stripping guesses or timezone conversions.
   *
   * A supplied day must really exist.
   * Expired dates remain valid input; eligibility is a separate policy.
   */
  function registrationDate(value) {
    const text = normalDigits(value ?? '')
      .trim()
      .replace(/[\u2010-\u2015]/g, '-')
      .replace(/[\u2044\u2215]/g, '/')
      .replace(/\s*([/-])\s*/g, '$1');

    const fail = (status, message) => ({
      status,
      value: '',
      message
    });

    if (!text) {
      return fail('empty', 'Enter the registration expiration month and year.');
    }

    let year;
    let month;
    let day;
    let match;

    if ((match = text.match(/^(\d{4})-(\d{1,2})(?:-(\d{1,2}))?$/))) {
      [, year, month, day] = match;
    } else if ((match = text.match(/^(\d{1,2})[/-](\d{4})$/))) {
      [, month, year] = match;
    } else if ((match = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/))) {
      [, month, day, year] = match;
    } else if ((match = text.match(/^(\d{2})(\d{4})$/))) {
      [, month, year] = match;
    } else if (
      (match = text.match(
        /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2})(?:\.\d{1,9})?)?(Z|[+-]\d{2}:\d{2})?$/
      ))
    ) {
      [, year, month, day] = match;
      const zone = match[7];

      if (
        +match[4] > 23 ||
        +match[5] > 59 ||
        +(match[6] || 0) > 59 ||
        (
          zone &&
          zone !== 'Z' &&
          (
            +zone.slice(1, 3) > 14 ||
            +zone.slice(4) > 59 ||
            (+zone.slice(1, 3) === 14 && +zone.slice(4) !== 0)
          )
        )
      ) {
        return fail(
          'invalid',
          'That date contains an invalid time. Enter its month and year as MM/YYYY.'
        );
      }
    } else {
      const monthPart = text.match(/^(\d{2})(?:\/|$)/);

      if (monthPart && (+monthPart[1] < 1 || +monthPart[1] > 12)) {
        return fail('invalid', 'The month must be 01 through 12.');
      }

      if (
        /^\d{0,6}$/.test(text) ||
        /^\d{1,2}\/\d{0,3}$/.test(text) ||
        /^\d{4}-$/.test(text)
      ) {
        return fail(
          'incomplete',
          'Finish the expiration date using two month digits and four year digits, for example 09/2027.'
        );
      }

      return fail(
        'invalid',
        'Enter a valid date such as 09/2027, 9/15/2027, or 2027-09-15.'
      );
    }

    if (+month < 1 || +month > 12) {
      return fail('invalid', 'The month must be 01 through 12.');
    }

    if (+year < 1000 || +year > 9999) {
      return fail('invalid', 'Enter a four-digit year from 1000 through 9999.');
    }

    if (day !== undefined) {
      const leap =
        +year % 4 === 0 && (+year % 100 !== 0 || +year % 400 === 0);

      const days = [
        31, leap ? 29 : 28, 31, 30, 31, 30,
        31, 31, 30, 31, 30, 31
      ];

      if (+day < 1 || +day > days[+month - 1]) {
        return fail(
          'invalid',
          'That day does not exist in the supplied month. Check the date on your registration.'
        );
      }
    }

    return {
      status: 'valid',
      value: `${String(+month).padStart(2, '0')}/${year}`,
      message: ''
    };
  }

  function integerText(value) {
    let text = normalDigits(value).trim();

    if (/^\d{1,3}(?:,\d{3})+$/.test(text)) {
      text = text.replaceAll(',', '');
    } else if (/^\d{1,3}(?:[ \u00a0\u202f]\d{3})+$/.test(text)) {
      text = text.replace(/[ \u00a0\u202f]/g, '');
    }

    if (!/^\d+$/.test(text) || !Number.isSafeInteger(Number(text))) {
      return null;
    }

    return String(Number(text));
  }

  function retryAfter(value) {
    if (!value) return 0;

    const milliseconds = /^\d+$/.test(value.trim())
      ? +value * 1000
      : Date.parse(value) - Date.now();

    return Number.isFinite(milliseconds)
      ? Math.min(30000, Math.max(0, milliseconds))
      : 0;
  }

  function delay(milliseconds, signal) {
    return new Promise((resolve, reject) => {
      if (signal.aborted) {
        reject(abortError());
        return;
      }

      const cancel = () => {
        clearTimeout(timer);
        reject(abortError());
      };

      const timer = setTimeout(() => {
        signal.removeEventListener('abort', cancel);
        resolve();
      }, milliseconds);

      signal.addEventListener('abort', cancel, { once: true });
    });
  }

  class UploadPage extends HTMLElement {
    connectedCallback() {
      clearTimeout(this.startTimer);

      if (!this.ready) {
        this.startTimer = setTimeout(() => this.start(), 0);
      }
    }

    start() {
      if (!this.isConnected || this.ready) return;

      // Custom elements can connect before the HTML parser adds their children.
      if (!this.$('details-form') || !this.$('book')) {
        this.startAttempts = (this.startAttempts || 0) + 1;

        if (this.startAttempts < 40) {
          this.startTimer = setTimeout(() => this.start(), 50);
        }
        return;
      }

      this.ready = true;
      this.dead = false;
      this.suspended = false;
      this.loading = false;
      this.switching = false;
      this.booking = false;
      this.uploading = false;

      this.cleanups = [];
      this.requests = new Set();
      this.composing = new Set();

      this.fields = [...this.querySelectorAll('[data-field]')];
      this.slots = [...this.querySelectorAll('[data-slot]')];

      this.order = '';
      this.resolved = {};
      this.generation = (this.generation || 0) + 1;

      this.pending = null;
      this.savePromise = null;
      this.revision = 0;
      this.savedRevision = 0;
      this.imageVersion = 0;
      this.imageRead = 0;

      this.ocrJobs = new Map();
      this.ocrToken = null;
      this.requireCompleteSave = false;
      this.lastSavedValues = null;

      this.api = safeUrl(
        this.dataset.api || 'https://api.driveready.co'
      ).replace(/\/$/, '');

      this.$('js-note').hidden = true;

      const keys = this.slots.map((slot) =>
        alias(slot.dataset.key.trim())
      );

      this.configured =
        !!this.api &&
        this.slots.length > 0 &&
        new Set(keys).size === keys.length &&
        keys.every((key) => /^[A-Za-z][A-Za-z0-9_]{0,99}$/.test(key));

      if (!this.configured) {
        this.notice(
          'This upload form needs a configuration correction. Please contact DriveReady.',
          true
        );
        this.update();
        return;
      }

      this.fields.forEach((input) => {
        if (input.tagName === 'SELECT') {
          input.replaceChildren(new Option('Choose state / province', ''));

          regionEntries.forEach(([code, name]) => {
            input.add(new Option(name, code));
          });
        }

        input._lastValue = input.value;

        this.listen(input, 'compositionstart', () => {
          this.composing.add(input);
          clearTimeout(this.saveTimer);
        });

        this.listen(input, 'compositionend', () => {
          this.composing.delete(input);
          this.handleInput(input, {
            inputType: 'insertCompositionText'
          });
        });

        this.listen(input, 'beforeinput', (event) => {
          input._beforeEdit = {
            value: input.value,
            start: input.selectionStart,
            end: input.selectionEnd,
            type: event.inputType
          };

          if (
            input.dataset.field === 'registrationDate' &&
            event.inputType === 'insertText' &&
            event.data === '/' &&
            input.selectionStart === 3 &&
            input.selectionEnd === 3 &&
            /^\d{2}\//.test(input.value)
          ) {
            // A user can type the slash naturally even after auto-insertion.
            event.preventDefault();
            input._beforeEdit = null;
          }
        });

        if (input.dataset.field === 'registrationDate') {
          this.listen(input, 'paste', (event) => {
            const text = event.clipboardData?.getData('text');
            if (typeof text !== 'string') return;

            const whole =
              input.selectionStart === 0 &&
              input.selectionEnd === input.value.length;

            const remaining = whole
              ? 0
              : input.value.length -
                (input.selectionEnd - input.selectionStart);

            if (text.length + remaining > 64) {
              event.preventDefault();

              this.dateFeedback(
                'That pasted value is too long. Paste a date such as 09/2027. Your existing value was kept.'
              );
              return;
            }

            // Allow native paste and undo. Normalize only a whole-field paste.
            input._pasteWhole = whole;
          });
        }

        this.listen(input, 'input', (event) => {
          this.handleInput(input, event);
        });

        this.listen(input, 'change', () => {
          if (input.value !== input._lastValue) {
            this.handleInput(input, {
              inputType: 'insertReplacementText'
            });
          }
        });

        this.listen(input, 'blur', () => {
          if (input.readOnly || this.composing.has(input)) return;

          input.dataset.touched = '1';
          const checked = this.fieldValue(input, false);

          if (!checked.error && checked.value !== input.value) {
            input.value = checked.value;
            this.recordEdit(input);
          }

          this.showFieldError(
            input,
            checked.error ||
              (
                input.required && !checked.value
                  ? `Enter ${prettyField(input).toLowerCase()}.`
                  : ''
              )
          );

          if (this.revision > this.savedRevision) {
            this.queueSave();
          }
        });
      });

      this.slots.forEach((slot, index) => {
        slot.dataset.key = keys[index];
        slot.remote = '';
        slot.version = 0;
        slot.dataset.state = 'pending';

        slot.querySelector('[data-number]').textContent =
          String(index + 1).padStart(2, '0');

        this.renderPhotoPreview(slot);

        const guide = slot.querySelector('[data-guide]');

        if (guide) {
          this.listen(guide, 'error', () => {
            guide.hidden = true;

            const fallback = slot.querySelector('[data-guide-fallback]');
            if (fallback) fallback.hidden = false;
          });
        }

        slot.querySelectorAll('[data-pick]').forEach((button) => {
          button.dataset.label = button.textContent.trim();

          this.listen(button, 'click', () => {
            if (this.canEdit() && !this.pending) {
              slot.querySelector(
                `[data-file="${button.dataset.pick}"]`
              ).click();
            }
          });
        });

        slot.querySelectorAll('[data-file]').forEach((input) => {
          this.listen(input, 'change', () => {
            const file = input.files?.[0];

            // Selecting the same file again must still fire a change event.
            input.value = '';

            if (file) this.selectFile(slot, file);
          });
        });
      });

      this.guides = [...this.querySelectorAll('[data-guide]')];

      if ('IntersectionObserver' in window) {
        this.guideObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach(({ target, isIntersecting }) => {
              if (!isIntersecting) return;

              // Shopify image URLs may be protocol-relative.
              const url = safeUrl(target.dataset.guide, location.href);
              if (url) target.src = url;

              this.guideObserver.unobserve(target);
            });
          },
          { rootMargin: '180px 0px' }
        );

        this.guides.forEach((guide) => {
          this.guideObserver.observe(guide);
        });
      } else {
        this.guides.forEach((guide) => {
          guide.loading = 'lazy';
          guide.src = safeUrl(guide.dataset.guide, location.href);
        });
      }

      this.listen(this.$('order-form'), 'submit', (event) => {
        event.preventDefault();
        this.load(this.$('order').value);
      });

      this.listen(this.$('details-form'), 'submit', (event) => {
        event.preventDefault();
        this.saveDetails(true);
      });

      this.listen(this.$('retry'), 'click', () => this.upload());
      this.listen(this.$('discard'), 'click', () => this.discard());
      this.listen(this.$('next'), 'click', () => this.nextMissing());
      this.listen(this.$('book'), 'click', () => this.book());

      this.listen(window, 'offline', () => {
        this.notice(
          'You are offline. Saved uploads are safe. Keep this page open, reconnect, then retry unfinished uploads.',
          true
        );
      });

      this.listen(window, 'online', () => {
        this.notice(
          'Connection restored. Retry any unfinished upload. Unsaved valid details will be retried automatically.'
        );

        if (this.revision > this.savedRevision) {
          this.queueSave();
        }
      });

      this.listen(window, 'beforeunload', (event) => {
        if (
          this.pending ||
          this.savePromise ||
          this.revision > this.savedRevision
        ) {
          event.preventDefault();
          event.returnValue = '';
        }
      });

      this.listen(window, 'pagehide', () => {
        this.suspended = true;
        this.composing.clear();
        clearTimeout(this.saveTimer);

        this.uploadRun = (this.uploadRun || 0) + 1;
        this.pending?.controller?.abort();
        this.xhr?.abort();

        this.requests.forEach((controller) => controller.abort());
        this.uploading = false;

        if (this.pending) {
          this.pending.slot.dataset.state = 'error';
          this.status(
            this.pending.slot,
            'Upload interrupted — retry when you return'
          );
        }
      });

      this.listen(window, 'pageshow', (event) => {
        if (!event.persisted) return;

        this.suspended = false;

        this.notice(
          this.pending
            ? 'Welcome back. Retry or cancel the unfinished upload.'
            : 'Welcome back. Checking your saved uploads.'
        );

        if (this.order) {
          this.refreshImages().catch((error) => {
            if (!this.dead) this.notice(error.message, true);
          });
        }

        if (this.revision > this.savedRevision) {
          this.queueSave();
        }

        this.runOcr();
        this.update();
      });

      const params = new URLSearchParams(location.search);
      const id = ['orderID', 'orderId', 'order_id', 'orderid', 'id']
        .map((key) => params.get(key))
        .find(Boolean);

      this.$('order').value = id || '';
      this.update();

      if (id) {
        this.load(id);
      } else {
        this.notice(
          'Enter the inspection ID from your confirmation email to begin.'
        );
      }
    }

    $(name) {
      return this.querySelector(`[data-ui="${name}"]`);
    }

    listen(target, type, listener) {
      target.addEventListener(type, listener);

      this.cleanups.push(() => {
        target.removeEventListener(type, listener);
      });
    }

    canEdit() {
      return (
        this.configured &&
        !!this.order &&
        !this.dead &&
        !this.suspended &&
        !this.loading &&
        !this.switching &&
        !this.booking
      );
    }

    notice(text, error = false) {
      const node = this.$('notice');
      delete node.dataset.quiet;
      node.textContent = text;
      node.dataset.error = String(error);
    }

    status(slot, text) {
      slot.querySelector('[data-status]').textContent = text;
    }

    dateFeedback(text) {
      const node = this.$('date-error');
      node.hidden = !text;

      if (node.textContent !== text) {
        node.textContent = text;
      }
    }

    showFieldError(input, error) {
      if (error && input.dataset.touched) {
        input.setAttribute('aria-invalid', 'true');
      } else {
        input.removeAttribute('aria-invalid');
      }

      if (input.dataset.field === 'registrationDate') {
        this.dateFeedback(input.dataset.touched ? error : '');
      }
    }

    recordEdit(input) {
      // Includes deliberate clearing: OCR must not fill it again.
      input.dataset.edited = '1';
      input.removeAttribute('data-extracted');
      input._lastValue = input.value;
      this.revision++;
    }

    handleInput(input, event) {
      if (input.readOnly || !this.order || this.loading || this.dead) return;

      const before = input._beforeEdit;
      input._beforeEdit = null;

      const pastedWhole = input._pasteWhole;
      input._pasteWhole = false;

      if (
        !event.isComposing &&
        !this.composing.has(input) &&
        input.dataset.field === 'registrationDate'
      ) {
        if (pastedWhole) {
          const parsed = registrationDate(input.value);

          if (parsed.status === 'valid') {
            input.value = parsed.value;
          }
        } else if (
          event.inputType === 'insertText' &&
          /^\d{2}$/.test(input.value) &&
          input.selectionStart === input.value.length &&
          (
            !before ||
            (
              before.start === before.value.length &&
              before.end === before.value.length &&
              /^\d?$/.test(before.value)
            )
          )
        ) {
          // Only append a separator during straightforward month typing.
          // Deletion, selection replacement, middle edits, and undo stay native.
          input.value += '/';
          input.setSelectionRange(input.value.length, input.value.length);
        }
      }

      this.recordEdit(input);

      if (event.isComposing || this.composing.has(input)) {
        clearTimeout(this.saveTimer);
        this.$('save-status').textContent =
          'Finish typing to save your changes.';
        return;
      }

      const checked = this.fieldValue(input, false);
      this.showFieldError(input, checked.error);
      this.queueSave();
      this.update();
    }

    fieldValue(input, complete) {
      const key = input.dataset.field;
      const raw = input.value.trim();

      let value = raw;
      let error = '';

      // Recompute validity instead of retaining a stale custom error.
      input.setCustomValidity('');

      if (input.readOnly) return { value, error };

      if (!raw) {
        if (complete && input.required) {
          error = `Enter ${prettyField(input).toLowerCase()}.`;
        }
      } else if (key === 'registrationDate') {
        const parsed = registrationDate(raw);

        if (parsed.status === 'valid') {
          value = parsed.value;
        } else {
          error = parsed.message;
        }
      } else if (numericFields.has(key)) {
        const number = integerText(raw);

        if (number === null) {
          error = `${prettyField(input)} must be a whole number, without decimal points or letters.`;
        } else if (
          key === 'carYear' &&
          (+number < 1886 || +number > currentYear() + 2)
        ) {
          error = `Enter a vehicle year from 1886 through ${currentYear() + 2}.`;
        } else if (
          (key === 'numberOfDoors' || key === 'numberOfSeats') &&
          +number < 1
        ) {
          error = `${prettyField(input)} must be at least 1.`;
        } else {
          value = number;
        }
      } else if (key === 'vinNumber') {
        value = raw.toUpperCase().replace(/\s/g, '');

        if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(value)) {
          error = 'Enter a 17-character VIN. VINs do not contain I, O, or Q.';
        }
      } else if (input.tagName === 'SELECT') {
        const code = regionLookup.get(raw.toLowerCase());

        if (!code) {
          error = 'Choose a state or province from the list.';
        } else {
          value = code;
        }
      } else if (
        input.type === 'email' &&
        input.validity.typeMismatch
      ) {
        error = 'Enter a valid email address, for example name@example.com.';
      } else if (key === 'customerPhone') {
        const phone = normalDigits(raw);
        const match = phone.match(
          /^(\+?[\d\s().-]+?)(?:\s*(?:x|ext\.?)\s*\d{1,6})?$/i
        );
        const digits = match ? match[1].replace(/\D/g, '') : '';

        if (!match || digits.length < 7 || digits.length > 15) {
          error = 'Enter a phone number including your area or country code.';
        } else {
          value = phone;
        }
      }

      if (
        !error &&
        input.maxLength > 0 &&
        value.length > input.maxLength
      ) {
        error = `${prettyField(input)} is too long (maximum ${input.maxLength} characters).`;
      }

      input.setCustomValidity(error);
      return { value, error };
    }

    snapshot(complete = false) {
      const values = {};
      let first = null;

      if (this.composing.size) {
        return {
          values,
          error: 'Finish typing before saving.',
          input: [...this.composing][0]
        };
      }

      this.fields.forEach((input) => {
        const checked = this.fieldValue(input, complete);
        values[input.dataset.field] = checked.value;

        if (complete) input.dataset.touched = '1';
        this.showFieldError(input, checked.error);

        if (checked.error && !first) {
          first = {
            error: checked.error,
            input
          };
        }
      });

      return { values, ...(first || {}) };
    }

    setField(input, value, ocr = false) {
      if (!scalar(value)) return false;

      let next = String(value).trim();

      if (
        !next ||
        (
          ocr &&
          input.maxLength > 0 &&
          next.length > input.maxLength
        )
      ) {
        return false;
      }

      if (input.dataset.field === 'registrationDate') {
        const parsed = registrationDate(next);

        if (parsed.status === 'valid') {
          next = parsed.value;
        } else if (ocr) {
          return false;
        }
      } else if (numericFields.has(input.dataset.field)) {
        const numeric = integerText(next);

        if (numeric !== null) {
          next = numeric;
        } else if (ocr) {
          return false;
        }
      } else if (input.dataset.field === 'vinNumber') {
        next = next.toUpperCase().replace(/\s/g, '');
      }

      if (input.tagName === 'SELECT') {
        const code = regionLookup.get(next.toLowerCase());

        if (code) {
          next = code;
        } else if (ocr) {
          return false;
        } else if (
          ![...input.options].some((option) => option.value === next)
        ) {
          // Keep unexpected loaded values visible instead of silently dropping them.
          const option = new Option(
            `${next} — choose a state / province`,
            next
          );

          option.dataset.unrecognized = '1';
          input.add(option);
        }
      }

      const previous = input.value;
      input.value = next;

      const checked = this.fieldValue(input, false);

      if (ocr && checked.error) {
        input.value = previous;
        this.fieldValue(input, false);
        return false;
      }

      input._lastValue = input.value;

      if (checked.error) {
        input.dataset.touched = '1';
        this.showFieldError(input, checked.error);
      }

      return input.value !== previous;
    }

    endpoint(path, order = this.order) {
      return (
        `${this.api}/api/v1/inspection/${encodeURIComponent(order)}` +
        `/sync/${path}?orderID=${encodeURIComponent(order)}`
      );
    }

    async json(url, init = {}, timeout = 45000) {
      if (this.dead || this.suspended) throw abortError();

      const controller = new AbortController();
      let timedOut = false;

      this.requests.add(controller);

      const timer = setTimeout(() => {
        timedOut = true;
        controller.abort();
      }, timeout);

      try {
        const response = await fetch(url, {
          ...init,
          headers: {
            accept: 'application/json',
            ...init.headers
          },
          cache: 'no-store',
          signal: controller.signal
        });

        let result;

        try {
          result = await response.json();
        } catch (error) {
          if (controller.signal.aborted) throw error;

          throw new Error(
            response.status === 413
              ? 'The submitted data is too large.'
              : 'The service returned an unreadable response. Please retry.'
          );
        }

        if (!isRecord(result)) {
          throw new Error(
            'The service returned an unexpected response. Please retry.'
          );
        }

        if (!response.ok || result.ok === false) {
          throw new Error(
            errorMessage(
              result,
              `The request could not be completed (${response.status}). Please retry.`
            )
          );
        }

        return result;
      } catch (error) {
        if (timedOut) {
          throw new Error('The connection timed out. Please retry.');
        }

        if (controller.signal.aborted) throw abortError();

        if (error instanceof TypeError) {
          throw new Error(
            'Could not reach DriveReady. Check your connection and retry.'
          );
        }

        throw error;
      } finally {
        clearTimeout(timer);
        this.requests.delete(controller);
      }
    }

    async load(value) {
      if (
        !this.configured ||
        this.dead ||
        this.suspended ||
        this.pending ||
        this.loading ||
        this.switching ||
        this.booking
      ) {
        return;
      }

      const id = normalDigits(value || '').trim();

      if (!/^\d{10,20}$/.test(id)) {
        this.notice(
          'Enter the 10–20 digit inspection ID from your confirmation link.',
          true
        );
        this.$('order').focus();
        return;
      }

      // Lock switching before awaiting an outstanding save.
      this.switching = true;
      this.update();

      let generation = this.generation;

      try {
        if (this.savePromise || this.revision > this.savedRevision) {
          if (
            !(await this.saveDetails(false)) ||
            this.dead ||
            this.suspended
          ) {
            this.notice(
              'Your current details are not saved. Correct any invalid or incomplete input, then use Save details before switching inspections.',
              true
            );
            return;
          }
        }

        generation = ++this.generation;

        this.requests.forEach((controller) => controller.abort());
        this.ocrJobs.clear();
        this.ocrToken = null;
        clearTimeout(this.saveTimer);

        this.loading = true;
        this.notice('Loading your inspection…');
        this.update();

        const [data, images] = await Promise.all([
          this.json(this.endpoint('data', id)),
          this.json(this.endpoint('images', id))
        ]);

        if (
          this.dead ||
          this.suspended ||
          generation !== this.generation
        ) {
          return;
        }

        if (!isRecord(data.data) || !isRecord(images.images)) {
          throw new Error(
            'The inspection response is incomplete. Please retry.'
          );
        }

        // Commit only when both reads succeed. Failed switches keep the old record.
        this.order = id;
        this.resolved = isRecord(data.resolved)
          ? { ...data.resolved }
          : {};

        this.revision = 0;
        this.savedRevision = 0;
        this.lastSavedValues = null;
        this.imageVersion++;

        this.fields.forEach((input) => {
          input.value = '';
          input.setCustomValidity('');
          input.removeAttribute('aria-invalid');

          ['edited', 'extracted', 'touched'].forEach((key) => {
            delete input.dataset[key];
          });

          input.querySelectorAll?.('option[data-unrecognized]').forEach(
            (option) => option.remove()
          );

          input._lastValue = '';
          this.setField(input, data.data[input.dataset.field]);
        });

        this.slots.forEach((slot) => {
          slot.version++;
          slot.querySelector('[data-feedback]').hidden = true;
        });

        this.dateFeedback('');

        const check = this.snapshot(false);

        this.$('save-status').textContent = check.error
          ? `Review needed: ${check.error}`
          : 'Saved details loaded. Changes save automatically.';

        this.applyImages(images, true);

        this.$('ocr-status').textContent = '';
        this.$('order').value = id;
        this.$('order-summary').textContent = `#${id}`;
        this.$('order-panel').open = false;

        try {
          const url = new URL(location.href);

          ['orderId', 'order_id', 'orderid', 'id'].forEach((key) => {
            url.searchParams.delete(key);
          });

          url.searchParams.set('orderID', id);
          history.replaceState(history.state, '', url);
        } catch {
          // Restricted history must not turn a successful load into a failure.
        }

        this.notice(
          check.error
            ? 'Inspection loaded. Check the highlighted details before saving or booking.'
            : 'Your saved uploads are loaded. Add one photo or video at a time.',
          !!check.error
        );

        if (!check.error) {
          this.$('notice').dataset.quiet = 'true';
        }
      } catch (error) {
        if (
          !this.dead &&
          !this.suspended &&
          generation === this.generation
        ) {
          this.notice(
            `${error.message}${this.order ? ' Your current inspection is still open.' : ''}`,
            true
          );
          this.$('order-panel').open = true;
        }
      } finally {
        if (!this.dead && generation === this.generation) {
          this.loading = false;
          this.switching = false;
          this.update();
          this.runOcr();
        }
      }
    }

    imageUrl(images, key) {
      if (!isRecord(images)) return '';

      return safeUrl(
        images[key] ??
          (key === 'imgDriverLicense' ? images.imgDriverLicenseUrl : '')
      );
    }

    applyImages(payload, replace = false) {
      if (!isRecord(payload.images)) {
        throw new Error('Saved uploads could not be read. Please retry.');
      }

      const images = payload.images;

      this.slots.forEach((slot) => {
        const key = slot.dataset.key;

        if (this.pending?.slot === slot) return;

        if (
          !replace &&
          !own(images, key) &&
          !(
            key === 'imgDriverLicense' &&
            own(images, 'imgDriverLicenseUrl')
          )
        ) {
          // Upload responses can contain only the slot that was just saved.
          return;
        }

        const next = this.imageUrl(images, key);

        if (next !== slot.remote) {
          slot.version++;
        }

        slot.remote = next;
        slot.dataset.state = next ? 'saved' : 'pending';
        this.status(slot, next ? 'Saved ✓' : 'Not uploaded');

        const link = slot.querySelector('[data-view]');
        link.hidden = !next;

        if (next) {
          link.href = next;
        } else {
          link.removeAttribute('href');
        }

        this.renderPhotoPreview(slot);
      });

      this.update();
    }

    renderPhotoPreview(slot) {
      if (slot.dataset.kind !== 'image') return;

      const example = slot.querySelector('.dr-example');
      const url = safeUrl(slot.remote);

      if (!example || (url && example.dataset.uploadUrl === url)) {
        return;
      }

      example.querySelectorAll('[data-upload-preview]').forEach((preview) => {
        preview.onload = null;
        preview.onerror = null;
        preview.removeAttribute('src');
        preview.remove();
      });

      if (!url) {
        delete example.dataset.uploadUrl;
        return;
      }

      example.dataset.uploadUrl = url;

      const photo = document.createElement('img');
      photo.setAttribute('data-upload-preview', '');
      photo.alt = `Your uploaded photo: ${slot.dataset.title}`;
      photo.width = 480;
      photo.height = 320;
      photo.loading = 'lazy';
      photo.decoding = 'async';
      photo.referrerPolicy = 'no-referrer';

      photo.onerror = () => {
        if (
          this.dead ||
          example.dataset.uploadUrl !== url ||
          !photo.isConnected
        ) {
          return;
        }

        photo.onerror = null;
        photo.hidden = true;

        const fallback = document.createElement('span');
        fallback.setAttribute('data-upload-preview', '');
        fallback.className = 'dr-example-missing text-sm text-subdued';
        fallback.textContent =
          'Photo saved. Preview unavailable in this browser. Use View saved below to open it.';

        example.append(fallback);
      };

      example.append(photo);
      photo.src = url;
    }

    async refreshImages() {
      if (!this.order || this.dead || this.suspended) return;

      const generation = this.generation;
      const imageVersion = this.imageVersion;
      const read = ++this.imageRead;

      const payload = await this.json(this.endpoint('images'));

      if (
        generation === this.generation &&
        imageVersion === this.imageVersion &&
        read === this.imageRead &&
        !this.dead &&
        !this.suspended
      ) {
        this.applyImages(payload, true);
      }
    }

    fileError(slot, text) {
      const node = slot.querySelector('[data-feedback]');
      node.textContent = text;
      node.hidden = false;
    }

    selectFile(slot, file) {
      if (!this.canEdit() || this.pending) {
        this.notice(
          'Finish or cancel the current operation before choosing another file.',
          true
        );
        return;
      }

      slot.querySelector('[data-feedback]').hidden = true;

      const extension = (file.name.split('.').pop() || '').toLowerCase();

      const reported = (file.type || '')
        .toLowerCase()
        .split(';')[0]
        .trim()
        .replace(/^image\/jpg$/, 'image/jpeg');

      // Only fall back to the extension when the browser has no useful MIME.
      const mime =
        !reported || reported === 'application/octet-stream'
          ? TYPES[extension]
          : reported;

      const kind = slot.dataset.kind;
      const maximum = kind === 'video' ? 100000000 : 25000000;

      if (
        !mime ||
        !Object.values(TYPES).includes(mime) ||
        !mime.startsWith(`${kind}/`)
      ) {
        this.fileError(
          slot,
          kind === 'video'
            ? 'Choose an MP4, MOV, M4V, WebM, OGG, or 3GP video.'
            : 'Choose a JPG, PNG, WebP, HEIC, HEIF, or AVIF photo.'
        );
        return;
      }

      if (!file.size) {
        this.fileError(
          slot,
          'This file is empty. Choose the original photo or video again.'
        );
        return;
      }

      if (file.size > maximum) {
        this.fileError(
          slot,
          `Choose a file no larger than ${maximum / 1000000} MB.${
            kind === 'video'
              ? ' Record a shorter clip at 720p or 1080p instead of 4K.'
              : ''
          }`
        );
        return;
      }

      slot.version++;
      this.imageVersion++;
      this.ocrJobs.delete(slot.dataset.key);

      this.pending = {
        slot,
        file,
        mime,
        generation: this.generation,
        order: this.order,
        controller: new AbortController()
      };

      this.upload();
    }

    async upload() {
      const pending = this.pending;

      if (
        !pending?.file ||
        this.uploading ||
        this.dead ||
        this.suspended ||
        pending.generation !== this.generation
      ) {
        return;
      }

      if (pending.controller.signal.aborted) {
        pending.controller = new AbortController();
      }

      this.$('upload-progress').value = 0;
      this.$('upload-name').textContent = pending.slot.dataset.title;

      if (navigator.onLine === false) {
        pending.slot.dataset.state = 'error';
        this.status(pending.slot, 'Not saved — offline');

        this.$('upload-status').textContent =
          'You are offline. Reconnect, then tap Retry upload.';

        this.update();
        return;
      }

      const run = this.uploadRun = (this.uploadRun || 0) + 1;

      const active = () =>
        this.pending === pending &&
        !this.dead &&
        !this.suspended &&
        this.uploadRun === run &&
        pending.generation === this.generation;

      this.uploading = true;
      pending.slot.dataset.state = 'uploading';
      this.status(pending.slot, 'Uploading…');
      this.$('upload-status').textContent = 'Starting upload…';
      this.update();

      try {
        let result;

        for (let attempt = 0; attempt < 3; attempt++) {
          try {
            result = await this.sendFile(pending);
            break;
          } catch (error) {
            if (!active()) return;

            if (
              !error.retryable ||
              navigator.onLine === false ||
              attempt === 2
            ) {
              throw error;
            }

            const wait = Math.max(
              1000 * 2 ** attempt,
              error.retryAfter || 0
            );

            this.$('upload-status').textContent =
              `Connection interrupted. Retrying in ${Math.ceil(wait / 1000)} seconds (${attempt + 1}/2)…`;

            await delay(wait, pending.controller.signal);

            if (!active()) return;
          }
        }

        if (!active()) return;

        const key = pending.slot.dataset.key;
        const receipts = result?.upload?.uploaded;

        const receipt =
          isRecord(receipts) &&
          (
            receipts[key] ??
            (
              key === 'imgDriverLicense'
                ? receipts.imgDriverLicenseUrl
                : null
            )
          );

        if (!receipt) {
          throw new Error(
            'The service could not confirm this upload was saved. Retry or check View saved.'
          );
        }

        let images = isRecord(result.images) ? result.images : {};
        let url = this.imageUrl(images, key) || safeUrl(receipt);

        if (!url) {
          const fresh = await this.json(
            this.endpoint('images', pending.order)
          );

          if (!isRecord(fresh.images)) {
            throw new Error('The upload could not be confirmed. Please retry.');
          }

          images = fresh.images;
          url = this.imageUrl(images, key);
        }

        if (!active()) return;

        if (!url) {
          throw new Error(
            'The file was received, but its saved location could not be confirmed. Please retry.'
          );
        }

        pending.file = null;
        this.pending = null;
        this.imageVersion++;

        this.applyImages({
          images: {
            ...images,
            [key]: url
          }
        });

        this.notice(
          `${pending.slot.dataset.title} saved. You can add the next item.`
        );

        this.enqueueOcr(pending.slot);
      } catch (error) {
        if (active()) {
          pending.slot.dataset.state = 'error';

          this.status(
            pending.slot,
            'Not confirmed saved — please retry'
          );

          this.$('upload-status').textContent = error.message;

          this.notice(
            'Retry this file without selecting it again, or cancel and choose another. Previously saved uploads are retained.',
            true
          );
        }
      } finally {
        if (!this.dead && this.uploadRun === run) {
          this.uploading = false;
          this.xhr = null;
          this.update();
        }
      }
    }

    sendFile(pending) {
      return new Promise((resolve, reject) => {
        if (pending.controller.signal.aborted || !pending.file) {
          reject(abortError());
          return;
        }

        const xhr = new XMLHttpRequest();
        this.xhr = xhr;

        const url = new URL(this.endpoint('images', pending.order));
        url.searchParams.set('slotKey', pending.slot.dataset.key);

        url.searchParams.set(
          'filename',
          (pending.file.name || 'upload')
            .replace(/[\u0000-\u001f\u007f/\\]/g, '_')
            .slice(0, 200)
        );

        let settled = false;
        const cancel = () => xhr.abort();

        const finish = (error, result) => {
          if (settled) return;
          settled = true;

          pending.controller.signal.removeEventListener('abort', cancel);

          xhr.onload = null;
          xhr.onerror = null;
          xhr.ontimeout = null;
          xhr.onabort = null;
          xhr.upload.onprogress = null;

          if (error) reject(error);
          else resolve(result);
        };

        const fail = (text, retryable = false) => {
          const error = new Error(text);
          error.retryable = retryable;

          try {
            error.retryAfter = retryAfter(
              xhr.getResponseHeader('Retry-After')
            );
          } catch {
            error.retryAfter = 0;
          }

          finish(error);
        };

        try {
          xhr.open('POST', url.href);
          xhr.timeout =
            pending.slot.dataset.kind === 'video' ? 300000 : 120000;

          xhr.setRequestHeader('Accept', 'application/json');
          xhr.setRequestHeader('Content-Type', pending.mime);

          pending.controller.signal.addEventListener(
            'abort',
            cancel,
            { once: true }
          );

          xhr.upload.onprogress = (event) => {
            if (
              this.pending !== pending ||
              this.dead ||
              this.suspended ||
              !event.lengthComputable ||
              event.total <= 0
            ) {
              return;
            }

            const percent = Math.min(
              100,
              Math.max(0, Math.round(event.loaded / event.total * 100))
            );

            this.$('upload-progress').value = percent;

            this.$('upload-status').textContent =
              percent < 100
                ? `Uploading ${percent}% — keep this page open`
                : 'Upload received. Confirming it is saved…';

            this.status(
              pending.slot,
              percent < 100
                ? `Uploading ${percent}%`
                : 'Confirming save…'
            );
          };

          xhr.onload = () => {
            let result;

            try {
              result = JSON.parse(xhr.responseText);
            } catch {
              result = null;
            }

            if (
              xhr.status >= 200 &&
              xhr.status < 300 &&
              isRecord(result) &&
              result.ok === true
            ) {
              finish(null, result);
            } else {
              fail(
                errorMessage(
                  result,
                  xhr.status === 413
                    ? 'File is too large. Choose a smaller file.'
                    : `Upload could not be confirmed (${xhr.status}). Please retry.`
                ),
                [408, 429, 500, 502, 503, 504].includes(xhr.status)
              );
            }
          };

          xhr.onerror = () => {
            fail(
              'Connection interrupted. Earlier saved uploads are safe.',
              true
            );
          };

          xhr.ontimeout = () => {
            fail('Upload timed out. Try Wi-Fi or a shorter video.', true);
          };

          xhr.onabort = () => finish(abortError());

          // Send the original Blob; no base64, canvas, or full-size decode.
          xhr.send(pending.file);
        } catch {
          finish(
            new Error('This file could not be sent. Please choose it again.')
          );
        }
      });
    }

    discard() {
      if (!this.pending) return;

      const pending = this.pending;
      const slot = pending.slot;

      this.uploadRun = (this.uploadRun || 0) + 1;
      this.imageVersion++;
      slot.version++;

      this.pending = null;
      pending.controller.abort();
      pending.file = null;

      this.xhr?.abort();
      this.xhr = null;
      this.uploading = false;

      slot.dataset.state = slot.remote ? 'saved' : 'pending';

      this.status(
        slot,
        slot.remote ? 'Previous upload saved' : 'Not uploaded'
      );

      this.notice('Selection cleared. Checking saved uploads…');
      this.update();

      // Canceling a request does not undo a write already accepted by the server.
      this.refreshImages().catch((error) => {
        if (!this.dead && !this.suspended) {
          this.notice(error.message, true);
        }
      });
    }

    focusCard(target, scrollTarget = target) {
      if (!target) return;

      const progress = this.querySelector('.dr-progress');
      const top = parseFloat(getComputedStyle(progress).top) || 0;

      scrollTarget.style.scrollMarginTop =
        `${top + progress.getBoundingClientRect().height + 16}px`;

      scrollTarget.scrollIntoView({
        block: 'start',
        behavior: 'instant'
      });

      target.focus({ preventScroll: true });
    }

    nextMissing() {
      if (!this.order || this.loading) return;

      const slot =
        this.pending?.slot ||
        this.slots.find(
          (item) => item.dataset.required === '1' && !item.remote
        );

      if (slot) {
        this.focusCard(slot);
      } else {
        const form = this.$('details-form');
        form.scrollIntoView({ block: 'start' });

        form.querySelector(
          'input:not([readonly]):not(:disabled)'
        )?.focus({ preventScroll: true });
      }
    }

    update() {
      if (!this.ready || this.dead) return;

      const required = this.slots.filter(
        (slot) => slot.dataset.required === '1'
      );

      const saved = required.filter((slot) => !!slot.remote).length;
      const editable = this.canEdit();

      this.$('count').textContent = !this.order
        ? 'Open an inspection to view saved progress'
        : `${saved} of ${required.length} required items saved`;

      this.$('overall').max = Math.max(required.length, 1);
      this.$('overall').value = saved;

      this.$('next').textContent = this.pending
        ? 'Current upload'
        : saved === required.length
          ? 'Review details'
          : 'Next photo or video';

      this.$('next').disabled = !editable;
      this.$('media').disabled = !editable;
      this.$('fields').disabled = !editable;

      this.slots.forEach((slot) => {
        slot.querySelectorAll('[data-pick]').forEach((button) => {
          const label = slot.remote
            ? button.dataset.pick === 'camera'
              ? slot.dataset.kind === 'video'
                ? 'Record again'
                : 'Retake photo'
              : 'Replace file'
            : button.dataset.label || button.textContent.trim();

          button.textContent = label;

          button.setAttribute(
            'aria-label',
            `${label}: ${slot.dataset.title}`
          );

          button.disabled = !editable || !!this.pending;
        });
      });

      this.$('load').disabled =
        !this.configured ||
        this.loading ||
        this.switching ||
        this.booking ||
        this.suspended ||
        !!this.pending ||
        !!this.savePromise;

      this.$('order').disabled = this.$('load').disabled;

      this.$('load').textContent =
        this.loading || this.switching
          ? 'Opening…'
          : 'Open inspection';

      const panel = this.$('upload-panel');

      if (
        this.pending &&
        panel.parentElement !==
          this.pending.slot.querySelector('.dr-slot-body')
      ) {
        this.pending.slot.querySelector('.dr-slot-body').insertBefore(
          panel,
          this.pending.slot.querySelector('.dr-actions')
        );
      }

      panel.hidden = !this.pending;
      this.$('queue-note').hidden = !this.pending;

      this.$('queue-note').textContent = this.pending
        ? `Finish or cancel the upload for ${this.pending.slot.dataset.title} before choosing another file.`
        : '';

      this.$('retry').hidden = !this.pending || this.uploading;
      this.$('retry').disabled = this.suspended;

      this.$('discard').textContent = this.uploading
        ? 'Cancel upload'
        : 'Choose a different file';

      this.$('save').textContent = this.savePromise
        ? 'Saving details…'
        : 'Save details';

      this.$('save').setAttribute(
        'aria-busy',
        String(!!this.savePromise)
      );

      this.$('book').disabled =
        !editable ||
        !!this.pending ||
        !!this.savePromise ||
        saved !== required.length;

      this.$('book').textContent = this.booking
        ? 'Saving before booking…'
        : 'Save & choose a time ↗';

      this.$('book-note').textContent = !this.order
        ? 'Open your inspection, finish the uploads, and review your details.'
        : saved !== required.length
          ? 'Finish the required uploads, then review your details to book.'
          : 'Review your details and choose an appointment.';
    }

    queueSave() {
      clearTimeout(this.saveTimer);

      if (
        !this.order ||
        this.dead ||
        this.suspended ||
        this.loading
      ) {
        return;
      }

      const check = this.snapshot(false);

      if (check.error) {
        this.$('save-status').textContent =
          `Not saved yet: ${check.error}`;
        return;
      }

      this.$('save-status').textContent = this.savePromise
        ? 'Saving; your latest changes are queued…'
        : 'Unsaved changes';

      this.saveTimer = setTimeout(() => {
        this.saveTimer = null;
        this.saveDetails(false);
      }, 1000);
    }

    async saveDetails(manual = false) {
      clearTimeout(this.saveTimer);

      if (
        !this.order ||
        this.loading ||
        this.dead ||
        this.suspended
      ) {
        return false;
      }

      // A manual save joining an autosave requires complete validation too.
      this.requireCompleteSave = this.requireCompleteSave || manual;

      if (this.savePromise) {
        return this.savePromise;
      }

      const generation = this.generation;
      const order = this.order;
      let force = manual;

      const run = async () => {
        while (
          !this.dead &&
          !this.suspended &&
          generation === this.generation
        ) {
          /*
           * Validate INSIDE the loop, immediately before every possible POST.
           * Values and revision are captured together, synchronously.
           * Edits made during a previous request cannot bypass this check.
           */
          const check = this.snapshot(this.requireCompleteSave);

          if (check.error) {
            this.$('save-status').textContent =
              `Not saved yet: ${check.error}`;

            if (this.requireCompleteSave && check.input) {
              check.input.focus();
              check.input.reportValidity();
            }

            return false;
          }

          if (!force && this.savedRevision >= this.revision) {
            break;
          }

          if (navigator.onLine === false) {
            this.$('save-status').textContent =
              'Not saved — offline. Keep this page open until you reconnect.';
            return false;
          }

          const revision = this.revision;
          const values = { ...check.values };

          this.$('save-status').textContent = 'Saving details…';

          const result = await this.json(
            this.endpoint('data', order),
            {
              method: 'POST',
              headers: { 'content-type': 'application/json' },
              body: JSON.stringify(values)
            }
          );

          if (
            this.dead ||
            this.suspended ||
            generation !== this.generation ||
            order !== this.order
          ) {
            return false;
          }

          if (isRecord(result.resolved)) {
            this.resolved = {
              ...this.resolved,
              ...result.resolved
            };
          }

          this.savedRevision = revision;
          this.lastSavedValues = values;
          force = false;

          // Recheck even if revisions match: a manual caller may have joined.
        }

        if (
          this.dead ||
          this.suspended ||
          generation !== this.generation
        ) {
          return false;
        }

        const missing = this.fields.some(
          (input) =>
            input.required &&
            !input.readOnly &&
            !input.value.trim()
        );

        this.$('save-status').textContent = missing
          ? 'Draft saved. Complete required details before booking.'
          : 'All changes saved ✓';

        return true;
      };

      const promise = run().catch((error) => {
        if (
          !this.dead &&
          !this.suspended &&
          generation === this.generation
        ) {
          this.$('save-status').textContent =
            `Not saved: ${error.message} Use Save details to retry.`;
        }

        return false;
      });

      this.savePromise = promise;
      this.update();

      try {
        return await promise;
      } finally {
        // An old task must never clear the state of a newer task.
        if (this.savePromise === promise) {
          this.savePromise = null;
          this.requireCompleteSave = false;

          if (!this.dead) this.update();
        }
      }
    }

    enqueueOcr(slot) {
      const type = {
        imgRegistrationUrl: 'registration',
        imgDriverLicense: 'license',
        imgDashboardUrl: 'dashboard'
      }[slot.dataset.key];

      if (!type) return;

      this.ocrJobs.set(slot.dataset.key, {
        slot,
        type,
        version: slot.version,
        url: slot.remote,
        generation: this.generation,
        order: this.order
      });

      this.runOcr();
    }

    async runOcr() {
      if (this.ocrToken || !this.canEdit()) return;

      const token = this.ocrToken = {};

      try {
        while (
          this.ocrJobs.size &&
          this.ocrToken === token &&
          this.canEdit()
        ) {
          const [key, job] = this.ocrJobs.entries().next().value;
          this.ocrJobs.delete(key);

          const current = () =>
            !this.dead &&
            !this.suspended &&
            this.ocrToken === token &&
            job.generation === this.generation &&
            job.order === this.order &&
            job.slot.version === job.version &&
            job.slot.remote === job.url &&
            this.pending?.slot !== job.slot;

          if (!current()) continue;

          this.$('ocr-status').textContent =
            'Reading your document. You can keep uploading and editing.';

          try {
            const result = await this.json(
              `${this.api}/api/v1/ocr`,
              {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify({
                  orderID: job.order,
                  customer_id: this.resolved.customerId || null,
                  slotKey: key,
                  documentType: job.type
                })
              },
              60000
            );

            if (!current() || this.booking || this.switching) {
              continue;
            }

            const base = [
              result.extracted,
              result.prefill,
              result.data
            ].find(isRecord);

            if (!base) {
              throw new Error('No readable document fields were returned.');
            }

            const reg = isRecord(base.registration)
              ? base.registration
              : {};

            const lic = isRecord(base.license)
              ? base.license
              : isRecord(base.driverLicense)
                ? base.driverLicense
                : {};

            const dash = isRecord(base.dashboard)
              ? base.dashboard
              : {};

            const prefill = {
              ...base,

              customerName: firstValue(
                lic.customerName,
                lic.fullName,
                lic.name,
                base.customerName
              ),

              carMake: firstValue(
                reg.vehicleMake,
                reg.make,
                base.carMake
              ),

              carModel: firstValue(
                reg.vehicleModel,
                reg.model,
                base.carModel
              ),

              carYear: firstValue(
                reg.vehicleYear,
                reg.year,
                base.carYear
              ),

              vinNumber: firstValue(
                reg.vinNumber,
                reg.vin,
                base.vinNumber
              ),

              licensePlate: firstValue(
                reg.licensePlate,
                base.licensePlate
              ),

              state: firstValue(
                reg.registrationState,
                base.state
              ),

              registrationDate: firstValue(
                reg.registrationExpirationDate,
                reg.registrationDate,
                base.registrationDate
              ),

              numberOfDoors: firstValue(
                reg.numberOfDoors,
                base.numberOfDoors
              ),

              numberOfSeats: firstValue(
                reg.numberOfSeats,
                base.numberOfSeats
              ),

              driverLicenseNumber: firstValue(
                lic.driverLicenseNumber,
                lic.licenseNumber,
                base.driverLicenseNumber
              ),

              driverLicenseState: firstValue(
                lic.driverLicenseState,
                lic.state,
                base.driverLicenseState
              ),

              vehicleMileage: firstValue(
                dash.vehicleMileage,
                dash.odometerReading,
                dash.odometer,
                dash.mileage,
                base.vehicleMileage
              )
            };

            let changed = false;
            let rejected = false;

            this.fields.forEach((input) => {
              const value = prefill[input.dataset.field];

              if (
                input.readOnly ||
                !scalar(value) ||
                String(value).trim() === '' ||
                input.value.trim() ||
                input.dataset.edited ||
                this.composing.has(input)
              ) {
                return;
              }

              if (this.setField(input, value, true)) {
                input.dataset.extracted = '1';
                changed = true;
              } else {
                rejected = true;
              }
            });

            if (changed) {
              this.revision++;
              this.queueSave();
            }

            this.$('ocr-status').textContent = rejected
              ? 'Document checked. Some values could not be used; enter those manually and review the highlighted details.'
              : 'Document checked. Review any highlighted details before booking.';
          } catch {
            if (current()) {
              this.$('ocr-status').textContent =
                'Your document is saved. Automatic reading is unavailable; please enter its details below.';
            }
          }
        }
      } finally {
        if (this.ocrToken === token) {
          this.ocrToken = null;

          if (
            !this.ocrJobs.size &&
            this.$('ocr-status').textContent.startsWith('Reading your document')
          ) {
            this.$('ocr-status').textContent =
              'Automatic entry skipped because the document or form changed. Review your current details below.';
          }

          if (this.ocrJobs.size && this.canEdit()) {
            this.runOcr();
          }
        }
      }
    }

    async book() {
      if (
        !this.canEdit() ||
        this.pending ||
        this.savePromise ||
        this.slots.some(
          (slot) => slot.dataset.required === '1' && !slot.remote
        )
      ) {
        return;
      }

      const check = this.snapshot(true);

      if (check.error) {
        this.$('save-status').textContent = check.error;
        this.$('details-form').scrollIntoView({ block: 'start' });
        check.input?.focus({ preventScroll: true });
        check.input?.reportValidity();
        return;
      }

      const generation = this.generation;
      const order = this.order;

      // Open synchronously to retain the user's click gesture.
      let tab = null;

      try {
        tab = window.open('about:blank', '_blank');
        if (tab) tab.opener = null;
      } catch {
        // Fall back to the current tab after saving.
      }

      this.booking = true;
      this.update();

      try {
        if (
          !(await this.saveDetails(true)) ||
          this.dead ||
          this.suspended ||
          generation !== this.generation ||
          order !== this.order
        ) {
          tab?.close();
          return;
        }

        const latest = this.snapshot(true);

        if (
          latest.error ||
          !this.lastSavedValues ||
          JSON.stringify(latest.values) !== JSON.stringify(this.lastSavedValues)
        ) {
          tab?.close();

          this.notice(
            'Your details changed while saving. Review them and choose your appointment again.',
            true
          );
          return;
        }

        const values = this.lastSavedValues;

        const url = new URL(
          'https://cal.com/driveready.co/virtual-rideshare-inspection'
        );

        const names = {
          customerName: 'name',
          customerEmail: 'email',
          customerPhone: 'attendeePhoneNumber',
          inspectionName: 'order-name',
          inspectionType: 'inspection-type',
          carMake: 'car-make',
          carModel: 'car-model',
          carYear: 'car-year',
          carColor: 'car-color',
          licensePlate: 'license-plate',
          state: 'car-state',
          vehicleMileage: 'vehicle-mileage',
          numberOfDoors: 'doors-count',
          numberOfSeats: 'seats-count',
          vinNumber: 'car-vin',
          registrationDate: 'registration-date',
          driverLicenseNumber: 'license-number',
          driverLicenseState: 'driver-license-state'
        };

        Object.entries(names).forEach(([field, parameter]) => {
          if (values[field]) {
            url.searchParams.set(parameter, values[field]);
          }
        });

        url.searchParams.set('order-id', order);

        ['customer', 'vehicle', 'inspection'].forEach((name) => {
          const id = this.resolved[`${name}Id`];

          if (scalar(id) && String(id).trim()) {
            url.searchParams.set(`${name}-id`, String(id));
          }
        });

        if (tab && !tab.closed) {
          tab.location.replace(url.href);
        } else {
          location.assign(url.href);
        }
      } catch {
        tab?.close();

        if (!this.dead) {
          this.notice(
            'Your booking page could not be opened. Please try Save & choose a time again.',
            true
          );
        }
      } finally {
        if (!this.dead && generation === this.generation) {
          this.booking = false;
          this.update();
          this.runOcr();
        }
      }
    }

    disconnectedCallback() {
      this.dead = true;

      clearTimeout(this.startTimer);
      clearTimeout(this.saveTimer);

      this.generation = (this.generation || 0) + 1;
      this.uploadRun = (this.uploadRun || 0) + 1;

      this.guideObserver?.disconnect();
      this.pending?.controller?.abort();
      this.xhr?.abort();

      this.requests?.forEach((controller) => controller.abort());
      this.cleanups?.forEach((cleanup) => cleanup());

      this.ocrJobs?.clear();
      this.ocrToken = null;
      this.composing?.clear();

      if (this.pending) {
        this.pending.file = null;
      }

      this.pending = null;
      this.ready = false;
    }
  }

  customElements.define(TAG, UploadPage);
})();

  } catch(e) { console.error(e); }
})();
})();
